import React from 'react';
import { RouterProvider, createBrowserRouter } from 'react-router-dom';

import { screens } from '../screens';
import { TabNavigator } from './TabNavigator';
import ProtectedRoute from '../components/ProtectedRoute';

const stack = createBrowserRouter([
  { path: '/', element: <TabNavigator /> },
  { path: '/SignIn', element: <screens.SignIn /> },
  { path: '/SignUp', element: <screens.SignUp /> },
  { path: '/SignUpAccountCreated', element: <screens.SignUpAccountCreated /> },
  { path: '/ForgotPassword', element: <screens.ForgotPassword /> },
  { path: '/NewPassword', element: <screens.NewPassword /> },
  { path: '/ForgotPasswordSentEmail', element: <screens.ForgotPasswordSentEmail /> },
  { path: '/SendPhoneOtp', element: <screens.SendPhoneOtp /> },
  { path: '/VerifyEmail', element: <screens.VerifyEmail /> },
  { path: '/VerifyPhone', element: <screens.VerifyPhone /> },
  { path: '/SendEmailOtp', element: <screens.SendEmailOtp /> },
  { path: '/EmailVerified', element: <screens.EmailVerified /> },
  { path: '/PhoneVerified', element: <screens.PhoneVerified /> },
  { path: '/OrderSuccessful', element: <screens.OrderSuccessful /> },
  { path: '/OrderFailed', element: <screens.OrderFailed /> },
  { path: '/Blog', element: <screens.Blog/> },
  { path: '/WishlistEmpty', element: <ProtectedRoute><screens.WishlistEmpty/></ProtectedRoute> },
  { path: '/Library', element: <ProtectedRoute><screens.Library /></ProtectedRoute> },
  { path: '/EditProfile', element: <ProtectedRoute><screens.EditProfile /></ProtectedRoute> },
  { path: '/Product/:id', element: <screens.Product />},
  { path: '/BookViewer/:id', element: <ProtectedRoute><screens.BookViewer /></ProtectedRoute> },
  { path: '/Shop', element: <screens.Shop /> }, // ← unprotected access
  { path: '/article/:id', element: <screens.Article /> },
  { path: '/Reviews', element: <ProtectedRoute><screens.Reviews /></ProtectedRoute> },
  { path: '/Description', element: <ProtectedRoute><screens.Description /></ProtectedRoute> },
  { path: '/OrderHistory', element: <ProtectedRoute><screens.OrderHistory /></ProtectedRoute> },
  { path: '/Checkout', element: <ProtectedRoute><screens.Checkout /></ProtectedRoute> },
  { path: '/MyPromocodes', element: <ProtectedRoute><screens.MyPromocodes /></ProtectedRoute> },
  { path: '/SignOut', element: <ProtectedRoute><screens.SignOut /></ProtectedRoute> },
  { path: '/OrderHistoryEmpty', element: <ProtectedRoute><screens.OrderHistoryEmpty /></ProtectedRoute> },
  { path: '/DeleteAccount', element: <ProtectedRoute><screens.DeleteAccount /></ProtectedRoute> },
  { path: '/ShippingAndPaymentInfo', element: <ProtectedRoute><screens.ShippingAndPaymentInfo /></ProtectedRoute> },
  { path: '/InfoSaved', element: <ProtectedRoute><screens.InfoSaved /></ProtectedRoute> },
  { path: '/LeaveAReview', element: <ProtectedRoute><screens.LeaveAReview /></ProtectedRoute> },
  { path: '/MyPromocodesEmpty', element: <ProtectedRoute><screens.MyPromocodesEmpty /></ProtectedRoute> },
  { path: '/Profile', element: <ProtectedRoute><screens.Profile /></ProtectedRoute> },
  { path: '/Library', element: <ProtectedRoute><screens.Library /></ProtectedRoute> },

]);

export const StackNavigator: React.FC = () => {
  return <RouterProvider router={stack} />;
};
